import { render, staticRenderFns } from "./VehicleDepartureCardV2.vue?vue&type=template&id=b90d7f6c&scoped=true"
import script from "./VehicleDepartureCardV2.vue?vue&type=script&lang=js"
export * from "./VehicleDepartureCardV2.vue?vue&type=script&lang=js"
import style0 from "./VehicleDepartureCardV2.vue?vue&type=style&index=0&id=b90d7f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90d7f6c",
  null
  
)

export default component.exports